import { render, staticRenderFns } from "./InputReseller.vue?vue&type=template&id=5c864c22"
import script from "./InputReseller.vue?vue&type=script&lang=js"
export * from "./InputReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports